<template>
    <list-page icone="mdi-account-child" titulo="Beneficiário" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:botoes>
          <div style="display: flex; align-items: center; justify-content: center;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="click" class="mr-4 mb-2" v-on="on" @click="AbrirMapa()" style="margin-top: 10px" :disabled="UsuarioRestrito(['G','B','E'])">
                  <v-icon>mdi-map-marker-account</v-icon>
                </v-btn>
              </template>
              <span>Mapa de Beneficiários</span>
            </v-tooltip>
            <info/>
          </div>
        </template>
        <template v-slot:corpo>

          <div class="cards-totalizadores-container mb-4">
            <v-card v-for="card in cardsTotalizadores" :key="card.chave" class="pa-3 totalizador-card" outlined :style="`background-color: ${card.corFundo}; border-color: ${card.corBorda};`">
              <div class="d-flex">
                <v-avatar size="28" :color="card.corIconeFundo" class="mr-3">
                  <v-icon small :color="card.corIcone">{{ card.icone }}</v-icon>
                </v-avatar>
                <div>
                  <div class="totalizador-titulo">{{ card.titulo }}</div>
                  <div class="totalizador-valor">{{ loadingTotalizadores ? '-' : card.valor }}</div>
                  <div class="totalizador-subtitulo">{{ card.subtitulo }}</div>
                </div>
              </div>
            </v-card>
          </div>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">

            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

              <v-tooltip right v-if="item.latitude != 0">
                <template v-slot:activator="{ on }">
                  <v-icon small @click="AbrirMapaBeneficiario(item)" v-on="on">mdi-map-marker</v-icon>
                </template>
                <span>Mapa</span>
              </v-tooltip>

            </template>

          </v-data-table>

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-beneficiario v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>
          <mapa v-model="dialogMapa" :item="coordenadas" @fechou="dialogMapa = false" @salvou="Atualizar()"/>

        </template>
    </list-page>
</template>
<script>
import {BeneficiarioService} from '@/core/services/projetos';
import {Beneficiario} from '@/core/domain/projetos';
import { EmpresaService } from '../../../core/services/geral';
import ListPage from "@/components/shared/ListPage";

const totalizadoresPadrao = () => ({
  totalBeneficiarios: 0,
  totalBeneficiariosProjetosAbertos: 0,
  totalBeneficiariosMenoresIdade: 0,
  totalBeneficiariosMaioresIdade: 0,
  totalBeneficiariosSemDataNascimento: 0
});

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value: 'actions', sortable: false },
        { text: '#', value: 'id', type:'number' },
        { text: 'Nome', value: 'nome' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Celular', value: 'celular' },
        { text: 'E-mail', value: 'email' },
      ],
      primeiraCarga: true,
      dialogMapa: false,
      coordenadas: [],
      tipoUsuario: '',
      empresaPlano: '',
      loadingTotalizadores: false,
      totalizadores: totalizadoresPadrao()
    }),
    computed: {
      cardsTotalizadores(){
        return [
          {
            chave: 'total',
            titulo: 'Total de beneficiarios',
            valor: this.totalizadores.totalBeneficiarios,
            subtitulo: 'Todos os beneficiarios',
            icone: 'mdi-account-group',
            corFundo: '#edf2f7',
            corBorda: '#d4dde8',
            corIconeFundo: '#dfe7f1',
            corIcone: '#3f5d7a'
          },
          {
            chave: 'abertos',
            titulo: 'Em projetos abertos',
            valor: this.totalizadores.totalBeneficiariosProjetosAbertos,
            subtitulo: 'Vinculos ativos unicos',
            icone: 'mdi-folder-open-outline',
            corFundo: '#eaf6ef',
            corBorda: '#d3e8dc',
            corIconeFundo: '#dceddf',
            corIcone: '#2f6f4f'
          },
          {
            chave: 'menores',
            titulo: 'Menores de idade',
            valor: this.totalizadores.totalBeneficiariosMenoresIdade,
            subtitulo: 'Idade menor que 18',
            icone: 'mdi-account-child-outline',
            corFundo: '#fff5e9',
            corBorda: '#f0dfc8',
            corIconeFundo: '#f8e9d4',
            corIcone: '#8a5a21'
          },
          {
            chave: 'maiores',
            titulo: 'Maiores de idade',
            valor: this.totalizadores.totalBeneficiariosMaioresIdade,
            subtitulo: 'Idade maior ou igual a 18',
            icone: 'mdi-account-check-outline',
            corFundo: '#f1eef9',
            corBorda: '#ddd6ee',
            corIconeFundo: '#e7e1f4',
            corIcone: '#5d4c8c'
          },
          {
            chave: 'sem-data',
            titulo: 'Sem data de nascimento',
            valor: this.totalizadores.totalBeneficiariosSemDataNascimento,
            subtitulo: 'Data de nascimento vazia',
            icone: 'mdi-calendar-question',
            corFundo: '#fbebea',
            corBorda: '#efd9d7',
            corIconeFundo: '#f7dfdd',
            corIcone: '#9b4942'
          }
        ];
      }
    },
    created() {
      this.service = new BeneficiarioService();
    },
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    methods: {
      Listar(filter, include){
        this.loading = true;
        this.loadingTotalizadores = true;

        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        this.service.Listar(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, filter, include)
          .then(
            res => {
              this.lista = res.data.items;
              this.totalLista = res.data.count;
            },
            err => {
              this.$swal('Aviso', err.response.data, 'error');
            }
          )
          .finally(() => {
            this.loading = false;
          });

        this.service.Totalizadores(this.search, this.headers, filter)
          .then(
            res => {
              this.totalizadores = res.data;
            },
            err => {
              this.totalizadores = totalizadoresPadrao();
              this.$swal('Aviso', err.response.data, 'error');
            }
          )
          .finally(() => {
            this.loadingTotalizadores = false;
          });
      },
      Novo(){
        this.NovoCadastro(new Beneficiario());
      },
      Editar(item){
        this.service.ObterPorId(item.id).then(
          res =>{
            this.EditarCadastro(new Beneficiario(res.data));
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
      },
      AbrirMapa(){
        this.primeiraCarga = true;
        this.service.CarregarCoordenadasMapa().then(
          res => {
            this.coordenadas = res.data;
            this.dialogMapa = true;
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        ).finally(() => {
          this.primeiraCarga = false;
        })
      },
      AbrirMapaBeneficiario(item)
      {
        let model = {
          id: item.id,
          nome: item.nome,
          latitude: item.latitude,
          longitude: item.longitude
        }
        this.coordenadas.push(model);
        this.dialogMapa = true;
      },
      UsuarioRestrito(plano){
        if(this.tipoUsuario == "MASTER"){
          return false;
        }
        if(plano.find(x => x == this.empresaPlano)){
          return true;
        }
        else{
          return false;
        }
      },
      Atualizar(){
        location.reload();
      }
    },
    mounted() {
      this.Listar();
      this.sessionApp = JSON.parse(localStorage.sessionApp);
      this.tipoUsuario = this.sessionApp.usuarioNome;

      new EmpresaService().ObterPorId(this.sessionApp.empresaId).then(
        res=>{
          this.empresaPlano = res.data.plano;
        }
      )
    }
}
</script>
<style scoped>
.totalizador-card {
  border-width: 1px;
  border-style: solid;
  min-height: 108px;
  width: clamp(220px, 18vw, 280px);
}

.cards-totalizadores-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: clamp(10px, 1.2vw, 20px);
}

@media (max-width: 600px) {
  .totalizador-card {
    width: 100%;
  }
}

.totalizador-titulo {
  font-size: 12px;
  color: #5f6a77;
  font-weight: 600;
  line-height: 1.3;
}

.totalizador-valor {
  font-size: 30px;
  font-weight: 700;
  color: #202b37;
  line-height: 1.1;
}

.totalizador-subtitulo {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
</style>
